import { BaseFilter } from '../shared/services/base.filter';
export class ClinicFilter extends BaseFilter {
}
